import Alteracao from "./Alteracao";

export default Alteracao;
